export default __webpack_public_path__ + "static/media/circle-time.7dfbc76a.svg";